;(function() {
  'use strict'

  controller.$inject = ["$scope", "facesService"];
  angular
    .module('app.messageCloseDialog')
    .controller('MessageCloseDialog', controller)

  /* @ngInject */
  function controller($scope, facesService) {
    $scope.moods = facesService.get()
  }
})()
